<div class="app-bg scroll-fix">

    <div class="container container-padding">

        <h1 class="page-header">{{ 'CALCULATION_SUMMARY' | translate }}</h1>

        <app-alert alertType="info" *ngIf="flag?.active === false">
            {{ 'SCHEDULE.APPLICATION_IS_NOT_ACTIVE' | translate }}
        </app-alert>

        <div class="separator"></div>

        <div class="box box-white has-shadow">
            <div class="box-content">
                <div class="box-body">
                    <div class="box-row">
                        <div class="box-item">
                            <div class="row">
                                <div class="col-auto">
                                    <app-output [label]="'POLICY_DATE_AND_CITY' | translate">
                                        <ng-container *ngIf="!offer.additionalData.location">
                                            {{ offer.statusDate | lsnDate }}
                                        </ng-container>
                                        <ng-container *ngIf="offer.additionalData.location">
                                            {{ offer.statusDate | lsnDate }}, {{ offer.additionalData.location }}
                                        </ng-container>
                                    </app-output>
                                </div>

                                <div class="col form-value-static" *ngIf="!readonly">
                                    <button class="btn btn-link btn-no-padding" (click)="editLocation()">
                                        <i class="icon-edit"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!offer.additionalData.location && matchers.location.errors.length === 0"
                         class="box-row">
                        <ng-container>
                            <app-alert alertType="warning" class="w-100 mb-4">
                                {{ 'SUMMARY.CITY_INFO_BOX' | translate }}
                            </app-alert>
                        </ng-container>
                    </div>

                    <div class="box-row" *ngIf="matchers.location.errors.length">
                        <app-alert alertType="danger" class="w-100 mb-4">
                            <div *ngFor="let error of matchers.location.errors">
                                {{ error.description ? error.description : error.code }}
                            </div>
                        </app-alert>
                    </div>
                </div>
            </div>
        </div>

        <div class="separator"></div>

        <app-clients-summary-box [document]="offer"
                                 [readonly]="readonly">
        </app-clients-summary-box>

        <div class="separator"></div>

        <app-property-summary-box [document]="offer"
                                  [fullInsuranceDate]="false"
                                  [readonly]="readonly">
        </app-property-summary-box>

        <div class="separator"></div>

        <app-motor-summary-box [document]="offer"
                               [fullInsuranceDate]="false"
                               [readonly]="readonly">
        </app-motor-summary-box>

        <div class="separator"></div>

        <div class="box mt-3" *ngIf="offer.premium !== null">
            <div class="box-body">
                <div class="row no-gutters">
                    <div class="col"></div>
                    <div class="col-auto">
                        <div class="text-price">
                            <div class="item-text">{{'OFFER_CONFIG.TOTAL_PREMIUM' | translate}}</div>
                            <div class="item-price">{{ offer.premium | premium }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="separator"></div>

        <app-clauses [offer]="initial"
                     [readonly]="readonly">
        </app-clauses>

        <div class="row form-row" *ngIf="matchers.generic.errors.length > 0">
            <div class="col">
                <app-message-box [errorStateMatcher]="matchers.generic"></app-message-box>
            </div>
        </div>

        <hr class="dimmed mt-4">

        <div class="row">
            <div class="col">
                <button [routerLink]="['/calculation', offer.id, 'card']"
                        class="btn btn-secondary">
                    {{ 'BUTTON.BACK' | translate }}
                </button>
            </div>
            <div class="col-auto" *ngIf="!readonly && hasFinishedProducts">
                <button (click)="createOffer()" class="btn btn-link">
                    {{ 'LABEL.GENERATE_OFFER' | translate }}
                </button>

                <button (click)="createPolicy()"
                        class="btn btn-primary"
                        *ngIf="isActiveSales">
                    {{ 'LABEL.SUBMIT_CALCULATION' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

